import styled from 'styled-components';

export const ButtonsContainer = styled.div`
    display: flex;
    gap: 1rem;
`;
